import axios from "@/plugins/axios";

let url = "/api/plugins/nicepayments/nicepay";

export const nicepayments = {
    nicepay: {
        generate(data, collection){
            return axios.post(`${url}/generate/${collection}`, data).then(result => result.data);
        },
    }
}